import { render, staticRenderFns } from "./quizQuestion.vue?vue&type=template&id=04eb84c4&"
import script from "./quizQuestion.vue?vue&type=script&lang=js&"
export * from "./quizQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports